/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Restore_Or_Contact_SupportInputs */

const en_plan_restore_or_contact_support = /** @type {(inputs: Plan_Restore_Or_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If your subscription looks wrong, restore purchases or contact support.`)
};

const es_plan_restore_or_contact_support = /** @type {(inputs: Plan_Restore_Or_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tu suscripción se ve incorrecta, restaura compras o contacta a soporte.`)
};

/**
* | output |
* | --- |
* | "If your subscription looks wrong, restore purchases or contact support." |
*
* @param {Plan_Restore_Or_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_restore_or_contact_support = /** @type {((inputs?: Plan_Restore_Or_Contact_SupportInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Restore_Or_Contact_SupportInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_restore_or_contact_support(inputs)
	return en_plan_restore_or_contact_support(inputs)
});